/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Submit_Content_MissingInputs */

const en_directory_submit_content_missing = /** @type {(inputs: Directory_Submit_Content_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} required field(s) left to fill.`)
};

const zh_directory_submit_content_missing = /** @type {(inputs: Directory_Submit_Content_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`还有 ${i?.count} 个必填项未填写。`)
};

/**
* | output |
* | --- |
* | "{count} required field(s) left to fill." |
*
* @param {Directory_Submit_Content_MissingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_content_missing = /** @type {((inputs: Directory_Submit_Content_MissingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Content_MissingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_content_missing(inputs)
	return zh_directory_submit_content_missing(inputs)
});
export { directory_submit_content_missing as "directory.submit.content.missing" }